// extracted by mini-css-extract-plugin
module.exports = {"metricCard":"styles-module__metricCard___1frTM"};